/**
 * Storlyn 品牌 - Member 页面配置
 */
import { memberCommonConfig } from './common'
import type { MemberPageConfig } from './types'
import { theme as brandTheme } from '@/config/brands'

export const theme = {
  avatarBorder: brandTheme.borderPrimary,
  btnPrimaryBg: 'rgba(216, 115, 147, 0.08)',
  topUpBtnBg: 'linear-gradient(90deg, #F7C7D8 0%, #E6A7C0 100%)',
  vipSubscribeBg: 'url(/images/storlyn/member_subscribe_bg.webp)',
  subscribeBg: 'linear-gradient(100deg, #FFF8FB 0%, #FDEAF2 58%, #F7E0EC 100%)',
  subscribeText: '#A95E81',
  subscribeText2: 'rgba(169, 94, 129, 0.58)',
  vipBtnBg: 'linear-gradient(90deg, #FF81B0 0%, #EE3BA4 100%)',
} as const

export const resources = {
  memberBg: '',
  userBg: '',
  userDefaultAvatar: '/images/storlyn/user-default.svg?v=3',
  memberVip: '/images/storlyn/member-vip.png',
  memberVipDiscount: '/images/storlyn/member-vip-discount.png',
} as const

export const memberConfig: MemberPageConfig = {
  theme,
  resources,
  texts: memberCommonConfig.texts,
}
